module.exports = __webpack_public_path__ + "img/pay.874c55bf.png";